import {REST_URL} from "../constants/constants";
import {toast} from "react-toastify";
import { log } from "../Helper";

export function getFromLocal(name) {
    return JSON.parse(window.localStorage.getItem(name));
}

export function setToLocal(name, data) {
    window.localStorage.setItem(name, JSON.stringify(data));
}

export function hasBPView(data) {
    return data?.businessRoles?.indexOf("BP_CAN_VIEW") > -1;
}

export function isEqual(obj1, obj2) {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
}

export  function sortByPriceWithCurrency (a,b) {
    if (typeof(a) != "number") {
        a = parseInt(a.replace(/[^0-9\.]+/g, ""))
      } 
      if (typeof(b) != "number") {
        b = parseInt(b.replace(/[^0-9\.]+/g, ""))
      }   
    return a-b;
  }

const notifySuccess = (message) => {
    toast.success(message);
};

export function documentsToDownload(docLinkArray) {
  for (let i = 0; i < docLinkArray.length; i++) {
    let docLink = docLinkArray[i];
    if (!docLink || !docLink.href) {
      log(`Invalid document link at index ${i}`);
      continue;
    }

    let url = docLinkArray[i].href;

    url = url.replace("http", "https");

    if (!url.includes(REST_URL)) {
      url = REST_URL + docLinkArray[i].href;
    }

    window.opener = null;
    let myWindow = window.open(url, "", "width=200, height=100");

    setTimeout(() => {
      myWindow.close();
    }, 3000);
  }

  notifySuccess("All documents are downloaded successfully");
}

export function documentsToDownloadCMR(docLinkArray) {
  for (let i = 0; i < docLinkArray.length; i++) {
    let docLink = docLinkArray[i];
    if (!docLink || !docLink.href) {
      log(`Invalid document link at index ${i}`);
      continue;
    }

    let url = docLinkArray[i].href;

    url = url.replace("http", "https");

    if (!url.includes(REST_URL)) {
      url = REST_URL + docLinkArray[i].href;
    }

    window.open(url, "_blank");
    notifySuccess("CMR document downloaded successfully");
  }
}
